import React, { Component, useEffect, useState } from 'react'

// table(components)
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import BoostrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { PageOptions } from '../../components/PageParams';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setReminder } from '../../../features/UserActions';
import { HttpJsonHeader } from '../../../features/Environments';

import { Button, OverlayTrigger, Tooltip  } from 'react-bootstrap';

import {AiOutlinePlus, AiFillEdit, AiOutlineDelete} from 'react-icons/ai';
import ConfirmDialog, { GetConfirmTitle } from '../../components/ConfirmDialog';
import styled from 'styled-components';
import PhysicianPopup from './PhysicianPopup';

export default function Phycian(props) {

    // ** UserInfo + Popup Message ***/
    const userDetail = useSelector((state)=> state.user.detail)
    const dispatch = useDispatch();    
    // ** Main State ***/
    const [custEditor, setCustEditor] = useState({show:false, action:null});
    const [data, setData] = useState([]);
    const [dataX, setDataX] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false); 
    const [confirmAction, setConfirmAction] = useState(null);
    const [updateFlag, setUpdateFlag]=useState(true);

    //if(winState == null) setWinState({show:false, setWinState:null});        
    useEffect(() => {        
        if(updateFlag){
           getData();     
           setUpdateFlag(false);
        }    
    }, [updateFlag]);

    
    useEffect(() => {        
        getDataX();    
    }, []);
    //----------------------------------------------------------------------  
    // ** List All rows
    const getData = async () =>{        
        await axios.post(process.env.REACT_APP_API + 'api/staff/phisician-list', 
                { BrchId: userDetail.brchid, SearchTxt:''} ,
                HttpJsonHeader)
            .then((res)=>{                                            
                setData(res.data && res.data.rows);                                 
            })
            .catch(err=> 
                  dispatch(setReminder({show:true, message: err.message, type:"error"}))                   
               );
      }
      //----------------------------------------------------------------------  
      // Get component for selection on editting window
      const getDataX = async() =>{
            await axios.post(process.env.REACT_APP_API + 'api/staff/getComponents', 
               { getForBranch:'y'},
                HttpJsonHeader)
            .then((res)=>{           
                //dispatch(setReminder({show:true, message: "บันทึกสมบูรณ์", type:'success'}))                     
                setDataX(res.data);                                
            })
            .catch(err=> 
                dispatch(setReminder({show:true, message: err, type:'error'}))
        );
      }
    //----------------------------------------------------------------------  
    // Actions
    // Save new Action
    const openAction = () =>{
        setCustEditor({show:true, action:null});
    }
    const actionNewData = ()=>{
        setSelectedRow({
            row:{staffid:0},
            action: openAction
        });     
    }  
    // Update Action
    const actionUpdate = (rowData) =>{        
        setSelectedRow({row:rowData, 
            action: openAction
        });       
           
    }
    // Delete Action
    const actionDelete = (row) =>{        
        setShowConfirm(true);                       
        setConfirmAction({ title: GetConfirmTitle("DELETE"), 
        data:row, 
        action:(row)=>{                 
                let dataToUpdate = {ItemInfo: row, UserInfo: userDetail};                 
                axios.post(process.env.REACT_APP_API + 'api/staff/delete',                     
                    dataToUpdate, HttpJsonHeader)
                    .then((res)=>{ setUpdateFlag(true); })
                    .catch(err=> { dispatch(setReminder({show:true, message: err.message, type:'error'})) });         
        }});  
    }
    //----------------------------------------------------------------------  
    //columns
    const getHeaderStyle = (wi)=>{
        return {
            width: wi, 
            background:'var(--table-header-back-color)'
        } 
    } 
    const customTextFilter = {      
        placeholder: "...",  
    }
    const formatEditBox = (x, row) => {
        return (
            <div>               
              <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>แก้ไข</Tooltip>}> 
                <Button variant='info'  className='info-button' onClick={()=>(actionUpdate(row))} > 
                  <AiFillEdit />
                </Button> 
              </OverlayTrigger> 
    
              <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>ลบ</Tooltip>}>      
                <Button variant='danger' className='info-button' onClick={()=>{actionDelete(row);}} > 
                  <AiOutlineDelete />
                </Button>
              </OverlayTrigger>         
            </div>
            )
      }
    //----------------------------------------------------------------------  
    // ** Columns List
    const columns = [
        {
            dataField:"staffcode", 
            text: "รหัสแพทย์" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('120px'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"physician_name", 
            text: "ชื่อแพทย์" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"nickname", 
            text: "ชื่อเล่น" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('150px'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"email", 
            text: "อีเมล์" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'left', paddingLeft:'10px'},      
            filter: textFilter(customTextFilter),                  
        },
        {
            dataField:"line_id", 
            text: "Line ID" ,
            sort: true,
            headerStyle:()=>getHeaderStyle('auto'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
        },


        {
            dataField:"box", 
            text: "-" ,            
            headerStyle:()=>getHeaderStyle('105px'),      
            style:{border:'none', color:'var(--table-text-color)', textAlign:'center'},      
            filter: textFilter(customTextFilter),                  
            formatter: formatEditBox
        },


    ];

    //----------------------------------------------------------------------  
    return (        
        <div>  
              <HBox>
                <OverlayTrigger placement='top' overlay={(props)=> <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}> 
                    <Button variant = 'primary'  style={{margin:'5px'}}
                        onClick={()=>actionNewData()} >
                        <AiOutlinePlus/> เพิ่มข้อมูลใหม่                  
                    </Button>                   
                </OverlayTrigger> 

                <div className='table-caption-box-right-flex'>
                     {"แพทย์ส่งตรวจประจำสาขา"}
                </div>    
        </HBox>
            
            <BoostrapTable
                    bootstrap4 keyField='staffid' 
                    rowClasses={'table-next-rows-style'}
                    data={data}  
                    columns={columns} 
                    striped  hover condensed             
                    headerWrapperClasses = "headerWrapper" 
                    wrapperClasses="bs-table-wrapper"                                        
                    bordered={ true }       
                    pagination = {paginationFactory( PageOptions)}  
                    filter={ filterFactory() }                     
                    // selectRow = {selectRow}           
                /> 
             <PhysicianPopup {...{winState:[custEditor, setCustEditor], selectedRow, dataX, setDataX, setUpdateFlag}} />                           
             <ConfirmDialog {...{showConfirm, setShowConfirm, confirmAction, setConfirmAction}} /> 
       </div>
    )
}

const HBox = styled.div`
    padding: 0px; 
    display: flex;       
`;




